module.exports = __webpack_public_path__ + "static/media/logoBQ.f69cefa4.svg";